export default __webpack_public_path__ + "static/media/hospital6.8f31ebe3.svg";